"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersListRequestStatus = void 0;
exports.OrdersListRequestStatus = {
    Pending: "pending",
    Refunded: "refunded",
    DisputeLost: "dispute-lost",
    Fulfilled: "fulfilled",
    Disputed: "disputed",
    Unfulfilled: "unfulfilled",
};
